import {Button, Modal} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../CoSoKBCB";
import {Formik, Form, useFormikContext} from "formik";
import {
  addPhieuKeHoach,
  updatePhieuKeHoach,
  searchdsDot,
  updateStatusDot,
  updateStatusNghiemThu, saveNghiemThu
} from "../services/services";
import {CODE, SELECTION_MODE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent, {ItemChangeProps} from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import FormThemVatTu from "./FormThemVatTu";
import DialogThongTinDot from "./DialogThongTinDot";
import DialogQuaTrinhChuyenGiao from "./DialogQuaTrinhChuyenGiao";
import OctTableCollapse from "../../../../component/table/table-collapse-custom/OctTableCollapse";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const DialogPhieuNghiemThu = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [itemSelected, setItemSelected] = useState<any>();
  const [dsDot, setDsDot] = useState<any>([]);
  const [searchObj, setSearchObj] = useState<any>({
    pageSize: 1000,
    pageIndex: 1,
  });
  const updatePageData = async () => {
    try {
      setIsLoading(true);
      const {data} = await searchdsDot(initialValues?.keHoach?.id);


      if (CODE.SUCCESS === data.code) {
        const list = [...(data.data || [])].map(item => {
          return (
            {
              ...item,
              subs: item?.evaluationList
            }
          )
        })
        setDsDot(list);

      } else {
        toast.error('Lỗi tìm kiếm phiếu, vui lòng thử lại');
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFormSubmit = async (values: any) => {
    const dataSubmit = {
      ...values.keHoach
    };
    console.log(values)
    console.log(dataSubmit)
    try {
      setIsLoading(true);
      const id = values.keHoach?.id;
      const {data} = await saveNghiemThu(id, dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        // setInitialValues && setInitialValues(data?.data);
        // setDetailPhieuKeHoach({
        //   ...data?.data,
        //   statusId: detailPhieuKeHoach.statusId,
        // });
        toast.success("Thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initialValues?.keHoach?.id && setDsKeHoach(initialValues?.keHoach?.listOfInstructions);
  }, [initialValues?.keHoach?.id]);

  useEffect(() => {
    updateForm();
    updateFormVatTu();
    updatePageData();
  }, []);

  const updateFormVatTu = async () => {
    if (!type?.formVatTu) return;
    const data = await generateForm(type?.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT(generateInitValues(data));
  };

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };

  const handleEdit = (rowData: any, index: number) => {
    setItemSelected(rowData);
    setOpenDialogThemMoi(true);
  }
  const handleCloseDialog = () => {
    setOpenDialogThemMoi(false);
  };
  const columns = [
    {
      name: "Đợt",
      field: "batchName",
      headerStyle: {
        justifyContent: 'center',
      },
      cellStyle: {
        width: "60px",
        textAlign: 'center',
      },
    },
    {
      name: "Giai đoạn",
      field: "statusName",
      cellStyle: {
        width: "240px",
      },
    },
    {
      name: "Đánh giá",
      field: "description",
    },
  ]


  const handlerUpdateStatus = async () => {

    const dataSubmit = {
      status: 4,
    };

    try {
      setIsLoading(true);
      const id = initialValues.keHoach?.id;
      const {data} = await updateStatusNghiemThu(id, dataSubmit)

      if (CODE.SUCCESS === data?.code) {
        onHide();
      } else {
        // let errorMessage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        // toast.warning(errorMessage);
      }
    } catch (error) {
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        // initialValues={{ keHoach: initialValuesFormThemVT }}
        initialValues={{
          keHoach: {
            ...generateInitValues(listJsonGenerate),
            ...initialValues?.keHoach,
            evaluationTechnique: initialValues?.keHoach?.transferTechniqueName,
            contractExecutedAmount: initialValues?.keHoach?.grandTotalAmount,
          }
        }}
        validationSchema={generateValidationSchema(listJsonGenerateVT, 'keHoach')}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Nghiệm thu`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <div className="spaces p-10 mb-10">
                  <GenerateFormComponent
                    isView={isView}
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    lstSelectedRenderButton={dsKeHoach}
                    setFieldValue={setFieldValue}
                    modelID={"keHoach"}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                    onFieldPropsChange={(data: ItemChangeProps) => {
                      let input: string = data?.currentInput ?? ''
                      let value = data?.value

                      if (input === 'trainingQuantity') {
                        setFieldValue('keHoach.trainingTotalAmount', Number(value) * Number(values?.keHoach?.trainingUnitPrice))
                      }
                      if (input === 'trainingUnitPrice') {
                        setFieldValue('keHoach.trainingTotalAmount', Number(value) * Number(values?.keHoach?.trainingQuantity))
                      }
                      if (input === 'implementationQuantity') {
                        setFieldValue('keHoach.implementationTotalAmount', Number(value) * Number(values?.keHoach?.implementationUnitPrice))
                      }
                      if (input === 'implementationUnitPrice') {
                        setFieldValue('keHoach.implementationTotalAmount', Number(value) * Number(values?.keHoach?.implementationQuantity))
                      }
                      if (input === 'evaluationQuantity') {
                        setFieldValue('keHoach.evaluationTotalAmount', Number(value) * Number(values?.keHoach?.evaluationUnitPrice))
                      }
                      if (input === 'evaluationUnitPrice') {
                        setFieldValue('keHoach.evaluationTotalAmount', Number(value) * Number(values?.keHoach?.evaluationQuantity))
                      }
                      if (['trainingQuantity', 'trainingUnitPrice', 'implementationQuantity', 'implementationUnitPrice', 'evaluationQuantity', 'evaluationUnitPrice'].includes(input)) {
                        setFieldValue('keHoach.grandTotalAmount', Number(values?.keHoach?.trainingTotalAmount) + Number(values?.keHoach?.implementationTotalAmount) + Number(values?.keHoach?.evaluationTotalAmount))
                        setFieldValue('keHoach.contractExecutedAmount', Number(values?.keHoach?.trainingTotalAmount) + Number(values?.keHoach?.implementationTotalAmount) + Number(values?.keHoach?.evaluationTotalAmount))
                      }
                      if (input === 'paidAmount') {
                        setFieldValue('keHoach.remainingAmount', Number(values?.keHoach?.grandTotalAmount) - Number(value))
                      }
                    }}
                  />
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    handleClick={(data: any) => {
                      data.code === "approved_done" && setIsView(true);
                    }}
                    tracker={type.trackerCode}
                    onHide={onHide}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
              </div>
            </Form>
          </>
        )}
      </Formik>
      {/*{openDialogThemMoi && <DialogBienBanHoTro*/}
      {/*  type={type}*/}
      {/*  show={openDialogThemMoi}*/}
      {/*  onHide={handleCloseDialog}*/}
      {/*  initialValues={{keHoach: {...itemSelected}}}*/}
      {/*  setInitialValues={setItemSelected}*/}
      {/*/>}*/}
      {openDialogThemMoi && <DialogQuaTrinhChuyenGiao
          type={type}
          show={openDialogThemMoi}
          onHide={handleCloseDialog}
          initialValues={{keHoach: {...itemSelected}}}
          setInitialValues={setItemSelected}
      />}
    </Modal>
  );
};

export default DialogPhieuNghiemThu;
